import { EarlyAccessDialog } from "@/components/integrations/dialog-early-access";
import { RequestIntegrationDialog } from "@/components/integrations/dialog-request-integration";
import { IntegrationsHeader } from "@/components/integrations/integrations-header";
import { useIntegrationDialogs } from "@/hooks/useIntegrationDialogs";
import { Outlet } from "react-router-dom";

export default function IntegrationsLayout() {
  const {
    openRequestDialog,
    setOpenRequestDialog,
    requestValue,
    setRequestValue,
    loadingRequest,
    successRequest,
    handleRequestSubmit,
    openEarlyAccessDialog,
    setOpenEarlyAccessDialog,
    earlyAccessValue,
    setEarlyAccessValue,
    loadingEarlyAccess,
    successEarlyAccess,
    handleEarlyAccessSubmit,
    openEarlyAccess,
    closeEarlyAccessDialog,
  } = useIntegrationDialogs();

  return (
    <>
      <div className="px-6 py-8 mx-auto max-w-7xl">
        <IntegrationsHeader />
        <Outlet context={{ openEarlyAccess, setOpenRequestDialog }} />
      </div>

      <RequestIntegrationDialog
        open={openRequestDialog}
        onOpenChange={setOpenRequestDialog}
        value={requestValue}
        onValueChange={setRequestValue}
        loading={loadingRequest}
        success={successRequest}
        onSubmit={handleRequestSubmit}
      />

      <EarlyAccessDialog
        open={openEarlyAccessDialog}
        onOpenChange={setOpenEarlyAccessDialog}
        value={earlyAccessValue}
        onValueChange={setEarlyAccessValue}
        loading={loadingEarlyAccess}
        success={successEarlyAccess}
        onSubmit={handleEarlyAccessSubmit}
        onClose={closeEarlyAccessDialog}
      />
    </>
  );
}
